import moment from "moment";
export const dataDefault = date => {
    const year = moment(date).format('YYYY');
    return [{
        name: '9.28',
        title: `${year} 预测数`,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.29',
        title: `${year} 预测数`,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.30',
        title: `${year} 预测数`,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.1',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.2',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.3',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.4',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.5',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.6',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.7',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '总计',
        title: year,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.28',
        title: year - 1 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.29',
        title: year - 1 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.30',
        title: year - 1 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.1',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.2',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.3',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.4',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.5',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.6',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.7',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '总计',
        title: year - 1,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.28',
        title: year - 2 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.29',
        title: year - 2 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '9.30',
        title: year - 2 + ' 实际数',
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.1',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.2',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.3',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.4',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.5',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.6',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '10.7',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }, {
        name: '总计',
        title: year - 2,
        occ: 0,
        adr: 0,
        room: 0,
        breakfast: 0,
        westernRestaurant: 0,
        chineseRestaurant: 0,
        wedd: 0,
        otherParty: 0,
        foodServiceIncome: 0,
        canSell: 0,
        takeUpRoom: 0,
        human: 0,
        hisHelper: 0,
        peopleWork: 0,
    }];
}

export const columnsData = print => [
    {
        title: "",
        key: "title",
        type: "text",
        width: 80,
    }, {
        title: "",
        key: "name",
        type: "textcenter",
        width: 50,
    }, {
        title: "OCC",
        key: "occ",
        type: "percent",
        width: 60,
    }, {
        title: "ADR",
        key: "adr",
        type: "number",
        width: 60,
    }, {
        title: "客房收入",
        key: "room",
        type: print ? "number" : "inputNumber"
    }, {
        title: "早餐收入",
        key: "breakfast",
        type: print ? "number" : "inputNumber"
    }, {
        title: "西餐厅（除早）",
        key: "westernRestaurant",
        type: print ? "number" : "inputNumber"
    }, {
        title: "中餐厅",
        key: "chineseRestaurant",
        type: print ? "number" : "inputNumber"
    }, {
        title: "婚宴",
        key: "wedd",
        type: print ? "number" : "inputNumber"
    }, {
        title: "其他宴会",
        key: "otherParty",
        type: print ? "number" : "inputNumber"
    }, {
        title: "餐饮总收入",
        key: "foodServiceIncome",
        type: print ? "number" : "inputNumber"
    }, {
        title: "可售房合计",
        key: "canSell",
        type: print ? "number" : "inputNumber"
    }, {
        title: "占用房合计",
        key: "takeUpRoom",
        type: print ? "number" : "inputNumber"
    }, {
        title: "",
        key: "human111",
        type: "text",
        width: 20,
    }, {
        title: "人力成本",
        key: "human",
        type: print ? "number" : "inputNumber"
    }, {
        title: "帮工费用",
        key: "hisHelper",
        type: print ? "number" : "inputNumber"
    }, {
        title: "人效",
        key: "peopleWork",
        type: "number",
        width: 60,
    }
];


// WEBPACK FOOTER //
// ./src/components/table/nationalDay/data.js